import React from 'react';
import { Select, SelectProps } from '@economic/taco';
import { useCurrentLocale } from '@economic/react-app';
import { t } from '@lingui/macro';
import useCachedQuery from '../../hooks/useCachedQuery';
import { Currency } from '../../../views/Currencies';

interface CurrencySelectOptionalProps {
    includeConverted?: boolean;
}
interface CurrencySelectProps extends SelectProps, CurrencySelectOptionalProps {}

export default function CurrencyDropdown(props: CurrencySelectProps) {
    const locale = useCurrentLocale();
    const query = useCachedQuery<Currency[]>('/currencies', []);
    let data;
    if (!query.loading) {
        data = query.data.map(currency => ({
            data: currency,
            text: currency,
            value: currency,
        }));

        if (props.includeConverted) {
            data.unshift({
                data: 'Converted',
                text: t`Converted`,
                value: 'Converted',
            });
        }
    }

    return <Select {...props} data={data} loading={query.loading} className="w-20" value={props.value || locale.currencyCode} />;
}
